import ProductCategoryGroupList from '@/data/productCategoryGroup/view/list.vue'

const list = {
  path: '/productCategoryGroup',
  name: 'productCategoryGroup-list',
  component: ProductCategoryGroupList
}

export default [list]
